module.exports = __webpack_public_path__ + "img/bolsa.4b25f64b.svg";